import React from 'react'
import {Typography} from '@mui/material'
import moment from 'moment'
import StatusPill from 'src/components-new/primitives/StatusPill'
import {ColumnDef} from 'src/components-new/data/DataTable'

export interface PerformanceRecord {
  id: number
  date?: string
  title?: string
  realBeneficiary?: string
  state?: string
  [key: string]: any
}

function getStateColor(state: string | undefined): 'success' | 'error' | 'warning' {
  const s = state?.toLowerCase()
  if (s === 'erogato') return 'success'
  if (s === 'non erogato') return 'error'
  return 'warning'
}

const DEFAULT_COLUMNS: ColumnDef<PerformanceRecord>[] = [
  {
    key: 'date',
    header: 'Data',
    render: (row) => (
      <Typography variant="body2">
        {row.date ? moment(row.date).format('ddd DD MMMM YYYY') : '—'}
      </Typography>
    ),
  },
  {
    key: 'title',
    header: 'Prestazione',
    render: (row) => (
      <Typography variant="body2">{row.title ?? '—'}</Typography>
    ),
  },
  {
    key: 'realBeneficiary',
    header: 'Beneficiario',
    render: (row) => (
      <Typography variant="body2">{row.realBeneficiary ?? '—'}</Typography>
    ),
  },
  {
    key: 'state',
    header: 'Stato',
    render: (row) => (
      <StatusPill
        label={row.state ?? '—'}
        color={getStateColor(row.state)}
      />
    ),
  },
]

interface PspColumnOption {
  id: string
  label: string
  type?: string
  format?: string
}

export function buildColumns(columnOptions?: PspColumnOption[]): ColumnDef<PerformanceRecord>[] {
  if (!columnOptions || columnOptions.length === 0) {
    return DEFAULT_COLUMNS
  }

  return columnOptions.map((col): ColumnDef<PerformanceRecord> => {
    if (col.id === 'date') {
      return {
        key: col.id,
        header: col.label,
        render: (row) => (
          <Typography variant="body2">
            {row.date ? moment(row.date).format(col.format ?? 'ddd DD MMMM YYYY') : '—'}
          </Typography>
        ),
      }
    }

    if (col.id === 'state') {
      return {
        key: col.id,
        header: col.label,
        render: (row) => (
          <StatusPill
            label={row.state ?? '—'}
            color={getStateColor(row.state)}
          />
        ),
      }
    }

    return {
      key: col.id,
      header: col.label,
      render: (row) => (
        <Typography variant="body2">{(row[col.id as keyof PerformanceRecord] as string) ?? '—'}</Typography>
      ),
    }
  })
}
